module.exports = __webpack_public_path__ + "media/images/fbcalls/5-47c48f99997e749af7803881d945849c.png";